import React from "react"
import { HeaderCard } from "../../components/Header"
import { LoadingWithLabel } from "../../components/Loading"
import { Grid } from "../../components/Table"
import moment from "moment"

import "./styles.scss"

export const LastestAppointmentsDetailsScreen = ({ eventDetails, goBack, loading }) => {
  const formatDate = (date) => (date ? moment(date).format("DD/MM/YYYY") : "Sem Data")

  const columnsProducers = [
    {
      id: "name",
      field: "name",
      label: "Produtor",
      width: "300px",
    },
    {
      id: "email",
      field: "email",
      label: "Email",
      width: "300px",
    },
  ]

  return (
    <div className="assistance-resolve-details-container" style={{ width: "100%" }}>
      <HeaderCard title="Detalhes do Atendimento" goBack={() => goBack()} />
      {loading ? (
        <div className="loading">
          <LoadingWithLabel colorSpinner="primary" labelLoading="Aguarde..." />
        </div>
      ) : Object.values(eventDetails)?.length > 0 ? (
        <div className="assistance-resolve-container">
          <>
            {eventDetails?.project && (
              <div className="assistance-resolve-details">
                <div className="details-title">Projeto: </div>
                <span>{eventDetails?.project}</span>
              </div>
            )}

            {eventDetails?.technician && eventDetails?.producerName && (
              <div className="assistance-resolve-details">
                <div className="details-title">Usuário(s): </div>
                <span>
                  <strong>Técnico(a): </strong> {eventDetails?.technician}
                </span>
                <span>
                  <strong>Produtor(a): </strong> {eventDetails?.producerName}
                </span>
              </div>
            )}

            {eventDetails?.responsible && eventDetails?.technician && (
              <div className="assistance-resolve-details">
                <div className="details-title">Usuário(s): </div>
                <span>
                  <strong>Quem criou: </strong> {eventDetails?.responsible}
                </span>
                <span>
                  <strong>Técnico(a): </strong> {eventDetails?.technician}
                </span>
              </div>
            )}

            {eventDetails?.typeAssistance && (
              <div className="assistance-resolve-details">
                <div className="details-title">Tipo do Atendimento: </div>
                <span>{eventDetails?.typeAssistance}</span>
              </div>
            )}

            {eventDetails?.formTitle && (
              <div className="assistance-resolve-details">
                <div className="details-title">Formulário: </div>
                <span>
                  <strong>Título: </strong> {eventDetails?.formTitle}
                </span>
                {eventDetails?.formType && (
                  <span>
                    <strong>Tipo: </strong> {eventDetails?.formType}
                  </span>
                )}
              </div>
            )}
            <div className="assistance-resolve-details">
              <div className="details-title">Evento: </div>
              <span>
                <strong>Titulo: </strong> {eventDetails?.eventTitle}
              </span>
              {eventDetails?.eventDescription && (
                <div className="details-text">
                  <span>
                    <strong>Descrição: </strong> {eventDetails?.eventDescription}
                  </span>
                </div>
              )}
              <span>
                <strong>Data de Atribuição: </strong>
                {formatDate(eventDetails?.dateToAdd || eventDetails?.executeDate)}
              </span>
              {eventDetails?.dateToRemove && (
                <span>
                  <strong>Data de Remoção: </strong>
                  {formatDate(eventDetails?.dateToRemove)}
                </span>
              )}
            </div>
            {/* {eventDetails?.tags && eventDetails.tags.length > 0 && (
              <div className="assistance-resolve-details">
                <div className="details-title">Tags: </div>
                <div className="assistance-resolve-details__list">
                  <ul>
                    {eventDetails?.tags &&
                      Array.isArray(eventDetails?.tags) &&
                      eventDetails?.tags.map((item) => <li>{item?.name}</li>)}
                  </ul>
                </div>
              </div>
            )} */}

            {eventDetails?.sectors && (
              <div className="assistance-resolve-details">
                <div className="details-title">Setor(es): </div>
                <div className="details-text">
                  <span>{eventDetails?.sectors?.split(",")?.join(", ")}</span>
                </div>
              </div>
            )}

            {eventDetails?.isFinished && eventDetails?.executeDate && (
              <div className="assistance-resolve-details">
                <div className="details-title">Status: </div>
                <span>
                  {eventDetails?.isFinished === "Aguardando Execução" ? (
                    <strong style={{ color: "#ff4001" }}>Aguardando Execução:</strong>
                  ) : (
                    <strong style={{ color: "#0146ad" }}>Executado:</strong>
                  )}
                  <> </>
                  {formatDate(eventDetails?.executeDate)}
                </span>
              </div>
            )}

            {eventDetails?.userNames && eventDetails.userNames.length > 0 && (
              <div className="assistance-resolve-details">
                <div className="details-title">Produtor(es): </div>
                <div className="assistance-resolve-details__list">
                  <Grid
                    columns={columnsProducers}
                    rows={eventDetails?.userNames}
                    showColumnVisibilityManager={false}
                  />
                </div>
              </div>
            )}
          </>
        </div>
      ) : (
        <div className="empty">Não foi possível buscar detalhes dos atendimentos</div>
      )}
    </div>
  )
}
